export default function FollowInstagram() {
  return (
    <a
      href="https://www.instagram.com/the_finding_spot/"
      target="_blank"
      rel="noopener noreferrer nofollow"
      className="ig-follow-icon"
    >
      <img
        src="/instagram.png"   // ⭐ matches your real file location
        alt="Follow us on Instagram"
        className="ig-icon-img"
      />
    </a>
  );
}
